import { GetVendorItemsPriceListResponse, VendorPriceListCreateResponse } from '@gtpl/shared-models/masters';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { VPLActivateOrDeActiveRequest } from './dto/activate-deactivate.request';
import { VendorItemRequestDto } from './dto/vendor-item.request';
import { VendorPriceListDto } from './dto/vendor-price-list-create.dto';
import { VendorRequestDto } from './dto/vendor.request';
import { VendorPriceListInfo } from './dto/vendors-price-list-info';
import { VendorsPriceListService } from './vendors-price-list.service';

@ApiTags('vendors-price-list')
@Controller('vendors-price-list')
export class VendorsPriceListController {
    constructor(private vendorListService:VendorsPriceListService){}


    /**
     * 
     * @param details 
     * @returns 
     */
    @Post('/CreateVendorPriceList')
    async CreateVendorPriceList(@Body() details:VendorPriceListInfo):Promise<VendorPriceListCreateResponse>{
        try{
            return await this.vendorListService.CreateVendorPriceList(details);
        }catch(error){
            throw error
        }
    }

    /**
     * 
     * @param request 
     * @returns item price details against vendor id
     */
    @Post('/GetVendorsPriceListForVendor')
    async GetVendorsPriceListForVendor(@Body() request:VendorRequestDto){
        try{
            return await this.vendorListService.GetVendorsPriceListForVendor(request.vendorId);
        }catch(error){
            throw error
        }
    }


    @Post('/GetItemPriceTaxForVendorIdItemId')
    async GetItemPriceTaxForVendorIdItemId(@Body() request:VendorItemRequestDto){
        try{
            return await this.vendorListService.GetItemPriceTaxForVendorIdItemId(request);
        }catch(error){
            throw error
        }
    }

    @Post('/ActivateOrDeActivateVPL')
    async ActivateOrDeActivateVPL(@Body() request:VPLActivateOrDeActiveRequest):Promise<GetVendorItemsPriceListResponse>{
        try{
            return await this.vendorListService.ActivateOrDeActivateVPL(request);
        }catch(error){
            throw error
        }
    }


}
